import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Parking = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 32 32"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M2 7C2 4.23858 4.23858 2 7 2H25C27.7614 2 30 4.23858 30 7V25C30 27.7614 27.7614 30 25 30H7C4.23858 30 2 27.7614 2 25V7ZM7 4C5.34315 4 4 5.34315 4 7V25C4 26.6569 5.34315 28 7 28H25C26.6569 28 28 26.6569 28 25V7C28 5.34315 26.6569 4 25 4H7ZM12 10C12 9.44772 12.4477 9 13 9H16.5C18.9853 9 21 11.0147 21 13.5C21 15.9853 18.9853 18 16.5 18H14V21C14 21.5523 13.5523 22 13 22C12.4477 22 12 21.5523 12 21V10ZM14 11V16H16.5C17.8807 16 19 14.8807 19 13.5C19 12.1193 17.8807 11 16.5 11H14Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Parking;
